import { __ } from '@wordpress/i18n';

document.addEventListener( 'DOMContentLoaded', function () {
	function sleep( time ) {
		return new Promise( ( resolve ) => setTimeout( resolve, time ) );
	}
	function isLogin() {
		return document.getElementsByClassName( 'otp-login-form' ).length;
	}

	if ( isLogin() >= 1 ) {
		// Return to the page that sent the visitor to log in (?redirect_to=),
		// instead of the plugin's fixed "redirect after login" page. Same-origin only.
		try {
			const target = new URLSearchParams( window.location.search ).get(
				'redirect_to'
			);
			if ( target ) {
				const url = new URL( target, window.location.origin );
				if ( url.origin === window.location.origin ) {
					document
						.querySelector( '.otp-login-form form' )
						.setAttribute( 'data-redirect', url.href );
				}
			}
		} catch ( e ) {}

		async function onClickContinueBtn() {
			await sleep( 1500 );
			submitBtn = document
				.getElementsByClassName( 'otp-login-form' )[ 0 ]
				.querySelector( '.send-otp-wrap input[value="Login"]' );
			if ( submitBtn ) {
				submitBtn.value = __( 'Login', 'anacrm' );
			}
			message = document
				.getElementsByClassName( 'otp-login-form' )[ 0 ]
				.querySelector( '.pg-form-responses div' );
			if (
				message &&
				message.innerText === 'OTP has been sent successfully.'
			) {
				message.innerText = __(
					"OTP has been sent successfully. Look in the spam folder if you don't see the mail in your inbox.",
					'anacrm'
				);
			}
			if ( message && message.innerText === 'User not exist' ) {
				message.innerText = __( 'User not exist', 'anacrm' );
			}
			if ( message && message.innerText === 'Wrong OTP used.' ) {
				message.innerText = __( 'Wrong OTP used.', 'anacrm' );
			}
		}

		const continueBtn = document
			.getElementsByClassName( 'otp-login-form' )[ 0 ]
			.querySelector( '.send-otp-wrap input[value="Send OTP"]' );
		let submitBtn = false;
		const passInputLabel = document
			.getElementsByClassName( 'otp-login-form' )[ 0 ]
			.getElementsByClassName( 'input-wrap' )[ 1 ]
			.querySelector( 'label' );
		const mailInputLabel = document
			.getElementsByClassName( 'otp-login-form' )[ 0 ]
			.getElementsByClassName( 'input-wrap' )[ 0 ]
			.querySelector( 'label' );
		let message = false;

		if ( continueBtn ) {
			continueBtn.value = __( 'Continue', 'anacrm' );
			continueBtn.addEventListener( 'mouseup', onClickContinueBtn );
		}
		if ( passInputLabel ) {
			passInputLabel.innerText = __(
				'Temporary password (you must use a new one each time you log in)',
				'anacrm'
			);
		}
		if ( mailInputLabel ) {
			mailInputLabel.innerText = __( 'Email', 'anacrm' );
		}
	}
} );
